import { isMobile } from 'react-device-detect';

const isMobileViewEnabled = process.env.REACT_APP_MOBILE_VIEW_FLAG === 'true';
export const FooterComponent = () => (
  <footer className={`footerWrapper ${(isMobile && isMobileViewEnabled) ? 'smallDevice' : ''}`}>
    <div>© {new Date().getFullYear()} Specialty Inspectors, LLC. All Right Reserved.</div>
    <div className="footer-credit">
      Powered by: <b>WBPRO</b>
    </div>
  </footer>
);
